import { render, staticRenderFns } from "./TabbarItem.vue?vue&type=template&id=0a465c30&"
import script from "./TabbarItem.vue?vue&type=script&lang=js&"
export * from "./TabbarItem.vue?vue&type=script&lang=js&"
import style0 from "./TabbarItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports